var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.locations),function(location,idx){return _c('span',{key:location.id},[(_vm.$currentUserCan(_vm.$permissions.PERM_VIEW_ANY_LOCATIONS))?_c('object-link',{attrs:{"object":location}}):_c('span',[_vm._v(_vm._s(_vm.$objectDenomination(location)))]),_vm._v(" "+_vm._s(_vm.locations.length - 1 > idx ? "," : " ")),_c('br')],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }